<template>
  <div style="border: 1px solid #ccc">
    <toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editorRef"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <editor
      style="height: 300px; overflow-y: hidden"
      v-model="valueHtml"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="handleCreated"
      @onChange="handleChange"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onBeforeUnmount, shallowRef, onMounted, reactive } from 'vue';
import '@wangeditor/editor/dist/css/style.css'; // 引入 css
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import { DomEditor } from '@wangeditor/editor';
export default defineComponent({
  name: 'RichTextEditor',
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    placeholder: {
      type: String,
      default: () => '',
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: [],
  setup(props, { emit }) {
    // 编辑器实例，必须用 shallowRef
    const editorRef = shallowRef();
    const editorConfig: any = reactive({
      placeholder: props.placeholder,
      readOnly: props.readOnly,
    });
    // 内容 HTML
    const valueHtml: any = ref('<p>hello</p>');
    onMounted(() => {
      setTimeout(() => {
        valueHtml.value = props.value;
        // valueHtml.value = '<p>模拟 Ajax 异步设置内容</p>';
        // console.log('editorRef.value', editorRef.value);
        // const editor = editorRef.value;
        // const toolbar = DomEditor.getToolbar(editor);
        // console.log('toolbarKeys', editor.getAllMenuKeys()); // 获取工具栏配置
        // console.log('toolbarKeys1', toolbar.getConfig().toolbarKeys); // 获取工具栏配置
        // console.log('valueHtml', valueHtml); // 打印文本内容
      }, 1500);
    });

    const toolbarConfig = {
      excludeKeys: ['uploadImage', 'uploadVideo'], // 去掉上传图片 上传视频
    };

    // 组件销毁时，也及时销毁编辑器
    onBeforeUnmount(() => {
      const editor = editorRef.value;
      if (editor == null) return;
      editor.destroy();
    });

    const handleCreated = editor => {
      editorRef.value = editor; // 记录 editor 实例，重要！
    };
    const handleChange = () => {
      emit('update:value', valueHtml.value);
    };
    const mode = ref('default'); // 或 'simple'
    return {
      editorRef,
      valueHtml,
      mode,
      toolbarConfig,
      editorConfig,
      handleCreated,
      handleChange,
    };
  },
  components: {
    Toolbar,
    Editor,
  },
});
</script>
